
export default class UtilsSet {

    // return A - B
    static difference(a:Set<any>, b:Set<any>) {
        return new Set([...a].filter(x => !b.has(x)));
    }

    static toggleValue(set:Set<any>, value:any) {
        if (set.has(value)) {
            set.delete(value);
        } else {
            set.add(value);
        }
    }

    static removeValues(set:Set<any>, shouldRemoveCallback: {(obj: any): boolean}) {
        set.forEach(obj => {
            if (shouldRemoveCallback(obj)) {
                set.delete(obj)
            }
        })
    }

}